export const URL_WITH_SCHEME_REGEX = /^https?:\/\/\S+/i;

export const hasHttpUrlScheme = (value: string) => URL_WITH_SCHEME_REGEX.test(value.trim());

export const extractMarketIntelligenceErrorMessage = (error: unknown) => {
  if (typeof error !== 'object' || error === null) {
    return null;
  }

  if ('data' in error && typeof error.data === 'object' && error.data !== null && 'error' in error.data && typeof error.data.error === 'string') {
    return error.data.error;
  }

  if ('error' in error && typeof error.error === 'string') {
    return error.error;
  }

  if ('message' in error && typeof error.message === 'string') {
    return error.message;
  }

  return null;
};
